import * as React from "react";
import { cn } from "../lib/utils";

export interface RadioOptionProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> {
  /** Optional longer description rendered under the label. */
  description?: React.ReactNode;
}

/**
 * A styled radio row (no Radix radio-group dependency). Compose several with a
 * shared `name` inside a `<fieldset role="radiogroup">` or use controlled props.
 */
const RadioOption = React.forwardRef<HTMLInputElement, RadioOptionProps>(
  ({ className, id, description, checked, disabled, children, ...props }, ref) => {
    return (
      <label
        className={cn(
          "flex cursor-pointer items-start gap-3 rounded-lg border border-border bg-card p-3 text-sm transition-colors hover:bg-secondary/60 has-[:focus-visible]:ring-2 has-[:focus-visible]:ring-ring has-[:checked]:border-primary has-[:disabled]:cursor-not-allowed has-[:disabled]:opacity-50",
          className,
        )}
      >
        <input
          ref={ref}
          id={id}
          type="radio"
          checked={checked}
          disabled={disabled}
          className="mt-0.5 size-4 shrink-0 accent-[hsl(var(--asrt-primary))]"
          {...props}
        />
        <span className="flex flex-col gap-1">
          {children}
          {description ? (
            <span className="text-xs text-muted-foreground">{description}</span>
          ) : null}
        </span>
      </label>
    );
  },
);
RadioOption.displayName = "RadioOption";

export { RadioOption };
